import { render, staticRenderFns } from "./positionAction.vue?vue&type=template&id=cba66b5e"
import script from "./positionAction.vue?vue&type=script&lang=js"
export * from "./positionAction.vue?vue&type=script&lang=js"
import style0 from "./positionAction.vue?vue&type=style&index=0&id=cba66b5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports